(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-texto-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-countdown]';
    var DIGIT_SELECTOR = '.banner-texto-countdown__digit';
    var CURRENT_SELECTOR = '.banner-texto-countdown__digit-current';
    var NEXT_SELECTOR = '.banner-texto-countdown__digit-next';

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function parseTarget(value) {
      if (!value) return null;
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return null;
      return date.getTime();
    }

    function getRemaining(targetTime) {
      var diff = Math.max(0, targetTime - Date.now());
      var totalSeconds = Math.floor(diff / 1000);
      return {
        days: pad(Math.floor(totalSeconds / 86400)),
        hours: pad(Math.floor((totalSeconds % 86400) / 3600)),
        minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
        seconds: pad(totalSeconds % 60)
      };
    }

    function resetDigitState(digitEl, value) {
      var currentEl = digitEl.querySelector(CURRENT_SELECTOR);
      var nextEl = digitEl.querySelector(NEXT_SELECTOR);
      if (!currentEl || !nextEl) return;

      digitEl.classList.add('is-resetting');
      digitEl.classList.remove('is-rolling');
      currentEl.textContent = value;
      nextEl.textContent = value;
      void digitEl.offsetHeight;
      digitEl.classList.remove('is-resetting');
    }

    function updateDigit(digitEl, nextChar, animate) {
      var currentEl = digitEl.querySelector(CURRENT_SELECTOR);
      var nextEl = digitEl.querySelector(NEXT_SELECTOR);
      if (!currentEl || !nextEl) return;

      var currentChar = currentEl.textContent;
      if (currentChar === nextChar) return;
      if (digitEl.classList.contains('is-rolling')) return;

      if (!animate) {
        resetDigitState(digitEl, nextChar);
        return;
      }

      nextEl.textContent = nextChar;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          digitEl.classList.add('is-rolling');
        });
      });

      function onTransitionEnd(event) {
        if (event.target !== currentEl) return;
        resetDigitState(digitEl, nextChar);
        currentEl.removeEventListener('transitionend', onTransitionEnd);
      }

      currentEl.addEventListener('transitionend', onTransitionEnd);
    }

    function updateUnit(unitEl, value, animate) {
      var digits = unitEl.querySelectorAll(DIGIT_SELECTOR);
      if (digits.length < 2) return;

      updateDigit(digits[0], value.charAt(0), animate);
      updateDigit(digits[1], value.charAt(1), animate);
    }

    function initCountdown(countdownEl) {
      if (countdownEl.dataset.countdownInitialized === 'true') return;

      var targetTime = parseTarget(countdownEl.getAttribute('data-target'));
      if (!targetTime) return;

      countdownEl.dataset.countdownInitialized = 'true';

      var units = {
        days: countdownEl.querySelector('[data-unit="days"]'),
        hours: countdownEl.querySelector('[data-unit="hours"]'),
        minutes: countdownEl.querySelector('[data-unit="minutes"]'),
        seconds: countdownEl.querySelector('[data-unit="seconds"]')
      };

      var previous = null;

      function tick(animate) {
        var remaining = getRemaining(targetTime);
        Object.keys(units).forEach(function (key) {
          if (!units[key]) return;
          var shouldAnimate = animate && previous && previous[key] !== remaining[key];
          updateUnit(units[key], remaining[key], shouldAnimate);
        });
        previous = remaining;
      }

      tick(false);
      window.setInterval(function () {
        tick(true);
      }, 1000);
    }

    function initAllCountdowns(root) {
      (root || document).querySelectorAll(SELECTOR).forEach(initCountdown);
    }

    initAllCountdowns();

    document.addEventListener('shopify:section:load', function (event) {
      initAllCountdowns(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jg-flip-board"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.flip-card').forEach((card) => {
      card.addEventListener('click', function () {
        if (window.innerWidth < 768) {
          this.querySelector('.flip-inner').classList.toggle('flipped');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
